import React, { Component } from "react";
import { connect } from "react-redux";
import produce from "immer";
import { classCodeAdd } from "../../actions/classCodesActions";

class Add extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddInput: false,
      cName: ""
    };
  }

  toggleForm = () => {
    this.setState(
      produce(draft => {
        draft.showAddInput = !draft.showAddInput;
        draft.cName = "";
      })
    );
  };

  handleChange = e => {
    const { value } = e.target;
    this.setState(
      produce(draft => {
        draft.cName = value;
      })
    );
  };

  handleSubmit = e => {
    e.preventDefault();
    const { cName } = this.state;
    let { classCodes } = this.props;
    classCodes = classCodes ? classCodes : [];

    /**
     * FILTER DUPLICATE
     */
    if (classCodes.includes(cName)) {
      alert(`이미 존재하는 클래스코드입니다.`);
      return false;
    }

    this.props.classCodeAdd([...classCodes, cName]);
    this.setState(
      produce(draft => {
        draft.cName = "";
      })
    );
  };

  Form = () => {
    const { cName } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <input
          type="text"
          name="cName"
          value={cName}
          onChange={this.handleChange}
          placeholder="클래스 코드 입력.."
        />
        <button
          type="submit"
          className="btn btn-outline-primary btn-sm ml-2"
          disabled={cName === ""}
        >
          추가
        </button>
      </form>
    );
  };

  render() {
    const { showAddInput } = this.state;
    return (
      <div className="ml-auto d-flex align-items-center">
        {/* TEXT INPUT */}
        {showAddInput && <this.Form />}
        {/* SHOW INPUT TOGGLE */}
        <div className="ml-2">
          <button
            type="button"
            className={`btn btn-sm btn-outline-${
              showAddInput ? "danger" : "secondary"
            }`}
            onClick={this.toggleForm}
          >
            {showAddInput ? "취소" : "+"}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({ classCodes: state.classCodes });

export default connect(
  mapStateToProps,
  { classCodeAdd }
)(Add);
